// import { push } from "connected-react-router";
//Upload Images Actions
import { fetchAPI } from "./";
import { BASE_URL, UPLOAD_URL, IMAGE_UPLOAD_URL } from "../config/constants";

export const downloadConfig = () => (dispatch, getState) => {
  let url = BASE_URL + "/apis/td_version_config/get";
  const { user_id, api_token: token } = getState().auth;
  let fd = new FormData();
  fd.append("user_id", user_id);

  let success = (res) => {
    if (res.status) {
      const { project_id, td_version_id } = res.config;
      dispatch({
        type: "SET_CONFIG_DATA",
        payload: res.config,
      });
      dispatch(getUserStats(project_id, td_version_id));
    }
  };

  let failure = () => {
    alert("No Data Recieved!");
  };

  fetchAPI({ url, token, fd, success, failure });
};

export const toggleUploadView = (type) => (dispatch) => {
  dispatch({ type: "TOGGLE_UPLOAD_VIEW", payload: type });
  dispatch(resetUploadingImages());
};

export const setUploadingImages = (type, title, fileList) => (dispatch) => {
  dispatch({
    type: "SET_UPLOADING_IMAGES",
    payload: { type, title, fileList },
  });
};

export const uploadingImageStart = () => ({ type: "UPLOADING_IMAGES_START" });

export const resetUploadingImages = () => (dispatch) => {
  dispatch({
    type: "RESET_UPLOADING_IMAGES",
  });
};

export const setActiveStore = (shopId) => (dispatch) => {
  dispatch({
    type: "SET_ACTIVE_STORE",
    payload: shopId,
  });
};

export const setActiveCategory = (catId) => (dispatch) => {
  dispatch({
    type: "SET_ACTIVE_CATEGORY",
    payload: catId,
  });
};

export const writeAnswer =
  (id, answer, type, sections) => (dispatch, getState) => {
    const { app } = getState();
    const { surveyData } = app;
    let updatedSurveyData = surveyData.map((survey) => {
      if (survey.sections == sections) {
        return {
          ...survey,
          questions: survey.questions.map((question) => {
            if (question.id == id) {
              let updatedAnswer = question.answer || [];
              const updateType = type.trim().toLowerCase();

              switch (updateType) {
                case "single":
                  updatedAnswer = [answer];
                  break;
                case "multiple":
                  if (updatedAnswer.includes(answer)) {
                    updatedAnswer.splice(updatedAnswer.indexOf(answer), 1);
                  } else {
                    updatedAnswer = [...updatedAnswer, answer];
                  }
                  break;
                case "freetext":
                  updatedAnswer = [answer];
                  break;
              }
              return {
                ...question,
                answer: updatedAnswer,
              };
            } else {
              return {
                ...question,
              };
            }
          }),
        };
      } else {
        return {
          ...survey,
        };
      }
    });
    // let updatedBeatPlan = shops.map((shop) => {
    //   if (shop.shop_id == activeStoreId) {
    //     return {
    //       ...shop,
    //       categories: shop.categories.map((category) => {
    //         if (category.category_id == activeCategoryId) {
    //           return {
    //             ...category,
    //             survey_questions: category.survey_questions.map((survey) => {
    //               if (survey.sections == sections) {
    //                 return {
    //                   ...survey,
    //                   questions: survey.questions.map((question) => {
    //                     if (question.id == id) {
    //                       let updatedAnswer = question.answer || [];
    //                       switch (type) {
    //                         case "single":
    //                           updatedAnswer = [answer];
    //                           break;
    //                         case "multiple":
    //                           if (updatedAnswer.includes(answer)) {
    //                             updatedAnswer.splice(
    //                               updatedAnswer.indexOf(answer),
    //                               1
    //                             );
    //                           } else {
    //                             updatedAnswer = [...updatedAnswer, answer];
    //                           }
    //                           break;
    //                         case "freetext":
    //                           updatedAnswer = [answer];
    //                           break;
    //                       }
    //                       return {
    //                         ...question,
    //                         answer: updatedAnswer,
    //                       };
    //                     } else {
    //                       return {
    //                         ...question,
    //                       };
    //                     }
    //                   }),
    //                 };
    //               } else {
    //                 return {
    //                   ...survey,
    //                 };
    //               }
    //             }),
    //           };
    //         } else {
    //           return {
    //             ...category,
    //           };
    //         }
    //       }),
    //     };
    //   } else {
    //     return {
    //       ...shop,
    //     };
    //   }
    // });

    dispatch({
      type: "UPDATE_SURVEY_DATA",
      payload: updatedSurveyData,
    });
  };

export const onMarkAsComplete = (data) => (dispatch, getState) => {
  const { api_token: token } = getState().auth;

  let url = BASE_URL + "/apis/td_survey_data/get";

  let fd = new FormData();
  for (let i in data) {
    fd.append(i, data[i]);
  }

  dispatch({ type: "MARKING_START" });

  let success = (res) => {
    dispatch({
      type: "MARKED_COMPLETE",
      payload: data.shop_id,
    });
    alert("Shop Marked");
  };
  let failure = (res) => {
    dispatch({
      type: "MARKED_FAILED",
      payload: res.message,
    });
    alert("Failed");
  };

  let catchFunc = (err) => {
    dispatch({
      type: "MARKED_FAILED",
    });
    alert("Failed");
  };

  fetchAPI({ url, fd, token, success, failure, catchFunc });
};

export const uploadImages =
  ({ data, context }) =>
  (dispatch, getState) => {
    const { api_token: token } = getState().auth;
    // const url = BASE_URL + "/apis/upload";
    const url = IMAGE_UPLOAD_URL + "/apis/upload";

    // const url = UPLOAD_URL;
    // "https://3la8ptp5d3.execute-api.us-east-1.amazonaws.com/dev";

    let fd = new FormData();
    for (let i in data) {
      fd.append(i, data[i]);
    }

    // fetch(url, {
    //   method: "POST",
    //   body: fd,
    //   headers: {
    //     "auth-token": token,
    //   },
    // })
    //   .then((res) => res.json())
    //   .then((res) => {
    //     console.log("image_upload_status", res);
    //     if (res === "Image file upload successful") {
    //       success(res);
    //     } else {
    //       failure(res);
    //       alert("Image Upload Failed!");
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     catchFunc(err);
    //   });

    let success = (res) => {
      dispatch({
        type: "UPDATE_PROCESSED_COUNTER",
      });
      dispatch({
        type: "SUCCESS_IMAGE_UPLOAD",
        payload: context,
      });
      dispatch({
        type: "REMOVE_UPLOADED_IMG",
        payload: context.image_id,
      });
    };

    let failure = (res) => {
      dispatch({
        type: "UPDATE_PROCESSED_COUNTER",
      });
      dispatch({
        type: "FAILED_APP_IMAGE_UPLOAD",
        payload: "Image Upload Failed!",
        // res.message
      });
    };

    let catchFunc = (err) => {
      dispatch({
        type: "UPDATE_PROCESSED_COUNTER",
      });
      return {
        type: "FAILED_APP_IMAGE_UPLOAD",
      };
    };

    fetchAPI({ url, fd, token, success, failure, catchFunc });
  };

export const getUserStats =
  (project_id, td_version_id) => (dispatch, getState) => {
    const url = BASE_URL + "/apis/user_stats";

    const { api_token: token, user_id } = getState().auth;

    let formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("project_id", project_id);
    formData.append("td_version_id", td_version_id);

    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        "auth-token": token,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {
          dispatch({
            type: "SET_USER_STATS",
            payload: res,
          });
        }
      })
      .catch((err) =>
        console.log("Something went wrong while fetching user stats.")
      );
  };
